import styled, { css } from "styled-components";

import { ReactComponent as DLogo} from "./images/dlogo.svg";
import { ReactComponent as ALogo } from "./images/alogo.svg";
import { ReactComponent as FLogo} from "./images/flogo.svg";
import { ReactComponent as ELogo} from "./images/elogo.svg";
import { ReactComponent as SLogo} from "./images/slogo.svg";

const DafesTitleWrapper = styled.div<{ currentTab: string }>`
  height: 64px;
  position: relative;
  svg {
    height: 100%;
    width: max-content;
    opacity: 0;
    transition: opacity 0.5s ease;
    
    &:not(.edu_design) {
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  
  ${({ currentTab }) => css`
    .${currentTab} {
      opacity: 1;
    }
  `}
`

const LOGOS = [
  {
    logo: DLogo,
    label: "edu_design"
  },
  {
    logo: ALogo,
    label: "edu_art"
  },
  {
    logo: FLogo,
    label: "edu_fashion"
  },
  {
    logo: ELogo,
    label: "edu_education"
  },
  {
    logo: SLogo,
    label: "edu_startups"
  }
]



const DafesTitle = ({ currentTab }: any) => {
  const list = LOGOS.map(({ logo: Logo, label }) => (
    <Logo className={label} key={label}/>
  ));

  return (
    <DafesTitleWrapper currentTab={currentTab}>
      {list}
    </DafesTitleWrapper>
  )
}

export default DafesTitle;import styled, { css } from "styled-components";

import { ReactComponent as DLogo} from "./images/dlogo.svg";
import { ReactComponent as ALogo } from "./images/alogo.svg";
import { ReactComponent as FLogo} from "./images/flogo.svg";
import { ReactComponent as ELogo} from "./images/elogo.svg";
import { ReactComponent as SLogo} from "./images/slogo.svg";

const DafesTitleWrapper = styled.div<{ currentTab: string }>`
  height: 64px;
  position: relative;
  svg {
    height: 100%;
    width: max-content;
    opacity: 0;
    transition: opacity 0.5s ease;
    
    &:not(.edu_design) {
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  
  ${({ currentTab }) => css`
    .${currentTab} {
      opacity: 1;
    }
  `}
`

const LOGOS = [
  {
    logo: DLogo,
    label: "edu_design"
  },
  {
    logo: ALogo,
    label: "edu_art"
  },
  {
    logo: FLogo,
    label: "edu_fashion"
  },
  {
    logo: ELogo,
    label: "edu_education"
  },
  {
    logo: SLogo,
    label: "edu_startups"
  }
]



const DafesTitle = ({ currentTab }: any) => {
  const list = LOGOS.map(({ logo: Logo, label }) => (
    <Logo className={label} key={label}/>
  ));

  return (
    <DafesTitleWrapper currentTab={currentTab}>
      {list}
    </DafesTitleWrapper>
  )
}

export default DafesTitle;